






















import Vue from 'vue';
import Dialog from '~/components/Dialog.vue';
import DialogMixin from '~/layouts/dialog.vue';

export default Vue.extend({
  components: {
    Dialog,
  },
  mixins: [DialogMixin],
});
